import { Box } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'

import { CoverOption, Quote } from '../../../domain'
import { TKey } from '../../../infrastructure/internationalisation'
import { AddOnBoolean } from './AddOnBoolean'

interface AddOnsMainProps {
  quote: Quote
  coverOptions: CoverOption[]
  onChange: (covers: CoverOption[]) => void
  default?: boolean
}

const tKey = TKey('components.add-on-selector')

export const AddOnSelector: FunctionComponent<AddOnsMainProps> = ({
  quote,
  coverOptions,
  onChange,
}) => {
  const onChangeCallback = useCallback(
    (coverOption: CoverOption) =>
      onChange(
        coverOptions.map((it) =>
          it.coverGroup === coverOption.coverGroup ? coverOption : it,
        ),
      ),
    [onChange, coverOptions],
  )

  const addOns = coverOptions.map((coverOption) => (
    <AddOnBoolean
      tKey={tKey}
      key={coverOption.coverGroup}
      quote={quote}
      coverOption={coverOption}
      onChange={onChangeCallback}
    />
  ))

  return <Box width={1}>{addOns}</Box>
}
